import ExcelJS from 'exceljs';

const COLUMN_COUNT = 16;

const BANK_OPTIONS_UY = [
  'Itau',
  'BROU',
  'Bandes',
  'BBVA',
  'Scotiabank',
  'Santander',
  'MIDINERO',
  'OCA Blue',
  'PREX',
  'N/A',
];

const BANK_OPTIONS_US = [
  'Bank of America',
  'Chase',
  'Wells Fargo',
  'Citibank',
  'U.S. Bank',
  'PNC Bank',
  'Capital One',
  'TD Bank',
  'Truist',
  'N/A',
];

const HEADERS = [
  'documento',
  'primerNombre',
  'segundoNombre',
  'primerApellido',
  'segundoApellido',
  'email',
  'celular',
  'departamento',
  'ciudad',
  'banco',
  'numeroCuenta',
  'moneda',
  'sueldoMensual',
  'sueldoMensualLiquido',
  'zafral',
  'genero',
];

const TEMPLATE_CONTENT = {
  es: {
    title: 'PayFlex · Alta masiva de usuarios',
    instruction:
      "Complete una fila por colaborador. No modifique los nombres de las columnas. Las columnas con 'OPCIONAL' o 'RECOMENDADO' pueden quedar vacías.",
    requirements: [
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OPCIONAL',
      'OBLIGATORIO',
      'OPCIONAL',
      'OBLIGATORIO',
      'RECOMENDADO',
      'OPCIONAL',
      'OPCIONAL',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
    ],
    descriptions: [
      'Cédula/documento sin puntos ni guiones.',
      'Primer nombre del colaborador.',
      'Segundo nombre del colaborador.',
      'Primer apellido del colaborador.',
      'Segundo apellido del colaborador',
      'Email personal o laboral. Debe ser único.',
      'Teléfono/celular. ',
      'Departamento. Opcional.',
      'Ciudad/localidad. Opcional.',
      'Banco o institución de pago.',
      'Número de cuenta. ',
      'Moneda del salario. ',
      'Sueldo mensual nominal/bruto.',
      'Sueldo líquido, después de retenciónes.',
      'Empleado zafral. Default false.',
      'Género. Opcional; default No especificado.',
    ],
    examples: [
      [
        '48921149',
        'María',
        '',
        'Bentos',
        '',
        'maria.bentos@empresa.com',
        '098123456',
        'Montevideo',
        'Montevideo',
        'Itau',
        '9828380',
        'UYU',
        '27.052',
        '',
        'false',
        'No especificado',
      ],
      [
        '51234567',
        'Juan',
        'Pablo',
        'Pérez',
        'Rodríguez',
        'juan.perez@empresa.com',
        '099456789',
        'Canelones',
        'Las Piedras',
        'BROU',
        '00123456789',
        'UYU',
        '42.000',
        '36.000',
        'false',
        'Masculino',
      ],
    ],
    filename: 'Alta masiva de usuarios - Carga usuarios',
  },
  esUs: {
    title: 'PayFlex · Alta masiva de usuarios',
    instruction:
      "Complete una fila por colaborador. No modifique los nombres de las columnas. Las columnas con 'OPCIONAL' o 'RECOMENDADO' pueden quedar vacías.",
    requirements: [
      'OPCIONAL',
      'OBLIGATORIO',
      'OPCIONAL',
      'OBLIGATORIO',
      'OPCIONAL',
      'OBLIGATORIO',
      'RECOMENDADO',
      'OPCIONAL',
      'OPCIONAL',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
      'OBLIGATORIO',
    ],
    descriptions: [
      'Licencia, SSN u otro ID. Opcional.',
      'Primer nombre del colaborador.',
      'Segundo nombre del colaborador.',
      'Primer apellido del colaborador.',
      'Segundo apellido del colaborador',
      'Email personal o laboral. Debe ser único.',
      'Teléfono/celular. ',
      'Estado. Opcional.',
      'Ciudad/localidad. Opcional.',
      'Banco o institución de pago.',
      'Número de cuenta. ',
      'Moneda del salario. ',
      'Sueldo mensual nominal/bruto.',
      'Sueldo líquido, después de retenciónes.',
      'Empleado zafral. Default false.',
      'Género. Opcional; default No especificado.',
    ],
    examples: [
      [
        'D1234567',
        'Sarah',
        '',
        'Johnson',
        '',
        'sarah.johnson@empresa.com',
        '3055551234',
        'Florida',
        'Miami',
        'Chase',
        '1234567890',
        'USD',
        '4,500',
        '',
        'false',
        'No especificado',
      ],
      [
        '',
        'Michael',
        'James',
        'Smith',
        'Brown',
        'michael.smith@empresa.com',
        '2125559876',
        'New York',
        'New York',
        'Bank of America',
        '9876543210',
        'USD',
        '5,200',
        '4,000',
        'false',
        'Masculino',
      ],
    ],
    filename: 'Alta masiva de usuarios - Carga usuarios',
  },
  en: {
    title: 'PayFlex · Bulk user upload',
    instruction:
      "Complete one row per employee. Do not modify the column names. Columns marked 'OPTIONAL' or 'RECOMMENDED' can be left empty.",
    requirements: [
      'MANDATORY',
      'MANDATORY',
      'OPTIONAL',
      'MANDATORY',
      'OPTIONAL',
      'MANDATORY',
      'RECOMMENDED',
      'OPTIONAL',
      'OPTIONAL',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
    ],
    descriptions: [
      'ID/document without dots or hyphens.',
      "Employee's first name.",
      "Employee's middle name.",
      "Employee's first last name.",
      "Employee's second last name",
      'Personal or work email. Must be unique.',
      'Phone/mobile. ',
      'State/Department. Optional.',
      'City/locality. Optional.',
      'Bank or payment institution.',
      'Account number. ',
      'Salary currency. ',
      'Nominal/gross monthly salary.',
      'Net salary, after withholdings.',
      'Zafral employee. Default false.',
      'Gender. Optional; default Not specified.',
    ],
    examples: [
      [
        '48921149',
        'María',
        '',
        'Bentos',
        '',
        'maria.bentos@empresa.com',
        '098123456',
        'Montevideo',
        'Montevideo',
        'Itau',
        '9828380',
        'UYU',
        '27.052',
        '',
        'false',
        'Not specified',
      ],
      [
        '51234567',
        'Juan',
        'Pablo',
        'Pérez',
        'Rodríguez',
        'juan.perez@empresa.com',
        '099456789',
        'Canelones',
        'Las Piedras',
        'BROU',
        '00123456789',
        'UYU',
        '42.000',
        '36.000',
        'false',
        'Male',
      ],
    ],
    filename: 'Bulk user upload - Users template',
  },
  enUs: {
    title: 'PayFlex · Bulk user upload',
    instruction:
      "Complete one row per employee. Do not modify the column names. Columns marked 'OPTIONAL' or 'RECOMMENDED' can be left empty.",
    requirements: [
      'OPTIONAL',
      'MANDATORY',
      'OPTIONAL',
      'MANDATORY',
      'OPTIONAL',
      'MANDATORY',
      'RECOMMENDED',
      'OPTIONAL',
      'OPTIONAL',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
      'MANDATORY',
    ],
    descriptions: [
      'License, SSN or other ID. Optional.',
      "Employee's first name.",
      "Employee's middle name.",
      "Employee's first last name.",
      "Employee's second last name",
      'Personal or work email. Must be unique.',
      'Phone/mobile. ',
      'State. Optional.',
      'City/locality. Optional.',
      'Bank or payment institution.',
      'Account number. ',
      'Salary currency. ',
      'Nominal/gross monthly salary.',
      'Net salary, after withholdings.',
      'Zafral employee. Default false.',
      'Gender. Optional; default Not specified.',
    ],
    examples: [
      [
        'D1234567',
        'Sarah',
        '',
        'Johnson',
        '',
        'sarah.johnson@empresa.com',
        '3055551234',
        'Florida',
        'Miami',
        'Chase',
        '1234567890',
        'USD',
        '4,500',
        '',
        'false',
        'Not specified',
      ],
      [
        '',
        'Michael',
        'James',
        'Smith',
        'Brown',
        'michael.smith@empresa.com',
        '2125559876',
        'New York',
        'New York',
        'Bank of America',
        '9876543210',
        'USD',
        '5,200',
        '4,000',
        'false',
        'Male',
      ],
    ],
    filename: 'Bulk user upload - Users template',
  },
};

function getTemplateContent(lang, isUsEmpresa = false) {
  if (isUsEmpresa) {
    return TEMPLATE_CONTENT[lang === 'en' ? 'enUs' : 'esUs'];
  }
  return TEMPLATE_CONTENT[lang === 'en' ? 'en' : 'es'];
}

function buildTemplateRows(lang, isUsEmpresa = false) {
  const content = getTemplateContent(lang, isUsEmpresa);
  const emptyRow = Array(COLUMN_COUNT).fill('');

  return [
    [content.title, ...emptyRow.slice(1)],
    [content.instruction, ...emptyRow.slice(1)],
    emptyRow,
    HEADERS,
    content.requirements,
    content.descriptions,
    ...content.examples,
  ];
}

function triggerDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function applyHeaderStyle(cell) {
  cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
  cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FF001F3F' },
  };
}

function applyInstructionStyle(cell) {
  cell.font = { color: { argb: 'FF000000' } };
  cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFE6F2FF' },
  };
}

function applyRequirementStyle(cell) {
  cell.font = { color: { argb: 'FF666666' } };
  cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
}

function applyDescriptionStyle(cell) {
  cell.font = { color: { argb: 'FF666666' } };
  cell.alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
  cell.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFF2F2F2' },
  };
}

export async function downloadBulkUploadTemplate({ lang = 'es', isUsEmpresa = false } = {}) {
  const content = getTemplateContent(lang, isUsEmpresa);
  const rows = buildTemplateRows(lang, isUsEmpresa);
  const bankOptions = isUsEmpresa ? BANK_OPTIONS_US : BANK_OPTIONS_UY;

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet('Carga usuarios');

  rows.forEach((row) => {
    sheet.addRow(row);
  });

  sheet.mergeCells(1, 1, 1, COLUMN_COUNT);
  sheet.mergeCells(2, 1, 2, COLUMN_COUNT);

  sheet.getRow(1).height = 28;
  sheet.getRow(2).height = 36;
  sheet.getRow(5).height = 22;
  sheet.getRow(6).height = 40;

  applyHeaderStyle(sheet.getCell('A1'));
  applyInstructionStyle(sheet.getCell('A2'));

  sheet.getRow(4).eachCell((cell) => {
    applyHeaderStyle(cell);
  });

  sheet.getRow(5).eachCell((cell) => {
    applyRequirementStyle(cell);
  });

  sheet.getRow(6).eachCell((cell) => {
    applyDescriptionStyle(cell);
  });

  sheet.columns = HEADERS.map((header, index) => ({
    key: header,
    width: index === 5 ? 30 : index === 13 ? 28 : 18,
  }));

  const bankColumnLetter = 'J';
  const exampleRowCount = content.examples.length;
  sheet.dataValidations.add(`${bankColumnLetter}7:${bankColumnLetter}${6 + exampleRowCount}`, {
    type: 'list',
    allowBlank: true,
    formulae: [`"${bankOptions.join(',')}"`],
    showErrorMessage: true,
    errorTitle: 'Banco inválido',
    error: 'Seleccioná un banco de la lista.',
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  triggerDownload(blob, `${content.filename}.xlsx`);
}
